// @ts-nocheck
import type { DataRef } from '../../types/binding';

function collectFromDataRef(ref: DataRef, out: Set<string>): void {
  if (ref.kind === 'expression' && typeof ref.expressionId === 'string') {
    out.add(ref.expressionId);
  }
}

function walkAst(node: Record<string, unknown> | null | undefined, out: Set<string>): void {
  if (!node || typeof node !== 'object') {
    return;
  }
  const kind = node.kind;
  if (kind === 'ref') {
    const ref = node.ref as DataRef | undefined;
    if (ref) {
      collectFromDataRef(ref, out);
    }
    return;
  }
  if (kind === 'literal') {
    return;
  }
  if (kind === 'unary') {
    walkAst(node.arg as Record<string, unknown>, out);
    return;
  }
  if (kind === 'binary') {
    walkAst(node.left as Record<string, unknown>, out);
    walkAst(node.right as Record<string, unknown>, out);
    return;
  }
  if (kind === 'if') {
    walkAst(node.when as Record<string, unknown>, out);
    walkAst(node.then as Record<string, unknown>, out);
    walkAst(node.else as Record<string, unknown>, out);
    return;
  }
  if (kind === 'callPure') {
    const args = node.args as unknown[] | undefined;
    if (Array.isArray(args)) {
      for (const arg of args) {
        if (arg && typeof arg === 'object') {
          walkAst(arg as Record<string, unknown>, out);
        }
      }
    }
  }
}

export function collectExpressionRefsFromAstRoot(
  root: Record<string, unknown> | null | undefined,
): string[] {
  const out = new Set<string>();
  walkAst(root, out);
  return [...out];
}
